import { DatePicker as MuiLabDatePicker } from "@mui/x-date-pickers";
import { TextField } from "@mui/material";
import { Component } from "react";
import { styled } from "@mui/material/styles";

const CustomTextField = styled(TextField)(({ theme }) => ({
    "& .MuiOutlinedInput-notchedOutline legend": {
        display: "none",
    },
}));

class DatePicker extends Component {
    render() {
        return (
            <MuiLabDatePicker
                {...this.props}
                toolbarTitle=""
                okText="Ok"
                cancelText="Annuler"
                renderInput={(params) => {
                    if (!this.props.value) {
                        params.inputProps.value = "";
                    }
                    return this.props.label ? (
                        <TextField
                            label={this.props.label}
                            fullWidth={this.props.fullWidth}
                            helperText={this.props.helperText}
                            {...params}
                            error={this.props.error}
                        />
                    ) : (
                        <CustomTextField
                            fullWidth={this.props.fullWidth}
                            helperText={this.props.helperText}
                            {...params}
                            error={this.props.error}
                        />
                    );
                }}
            />
        );
    }
}

export default DatePicker;
